/**
 * KpiSparkline — mini-graph SVG d'évolution sous un KPI.
 * Pas de lib externe — SVG pur, ultra léger.
 *
 * Props:
 *   - data: number[] (7-30 points)
 *   - tone: 'gold' | 'success' | 'warning' | 'neutral'
 *   - height: number (default 22)
 *   - showArea: bool (default true)
 */
const KpiSparkline = ({ data = [], tone = 'gold', height = 22, showArea = true }) => {
  if (!data || data.length < 2) {
    return <div style={{ height }} />;
  }
  const w = 100;
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const step = w / (data.length - 1);
  const points = data.map((v, i) => {
    const x = i * step;
    const y = height - ((v - min) / range) * (height - 4) - 2;
    return [x, y];
  });
  const pathD = points.map(([x, y], i) => `${i === 0 ? 'M' : 'L'}${x.toFixed(2)},${y.toFixed(2)}`).join(' ');
  const areaD = `${pathD} L${w},${height} L0,${height} Z`;

  const color = tone === 'gold'    ? 'var(--c-gold)' :
                tone === 'success' ? '#22C55E' :
                tone === 'warning' ? '#EAB308' :
                'rgba(255,255,255,0.5)';

  // Trend last vs first
  const last = data[data.length - 1];
  const first = data[0];
  const delta = last - first;
  const pct = first ? ((delta / first) * 100).toFixed(0) : 0;

  return (
    <div className="flex items-center gap-2 mt-1.5">
      <svg
        viewBox={`0 0 ${w} ${height}`}
        preserveAspectRatio="none"
        className="flex-1"
        style={{ height, overflow: 'visible' }}
      >
        {showArea && (
          <path
            d={areaD}
            fill={color}
            opacity={0.14}
          />
        )}
        <path
          d={pathD}
          fill="none"
          stroke={color}
          strokeWidth={1.4}
          strokeLinejoin="round"
          strokeLinecap="round"
          vectorEffect="non-scaling-stroke"
        />
        {/* Last point dot */}
        <circle
          cx={points[points.length - 1][0]}
          cy={points[points.length - 1][1]}
          r={1.6}
          fill={color}
        />
      </svg>
      {Math.abs(parseFloat(pct)) > 0 && (
        <span
          className="hud-tabular text-[9.5px] font-bold shrink-0"
          style={{ color: delta >= 0 ? '#86EFAC' : '#FCA5A5' }}
        >
          {delta >= 0 ? '+' : ''}{pct}%
        </span>
      )}
    </div>
  );
};

export default KpiSparkline;
